export default __webpack_public_path__ + "static/media/result_heavy.037694c7.png";